import React from "react";
import {KContainer} from "@kopjra/uikit";

export interface StateProps {
}

export interface DispatchProps {
}

export interface InnerProps {
}

export type Props = StateProps & DispatchProps & InnerProps;

export const Home: React.FC<Props> = () => {
    return (
        <div className="typeFormContainer" data-tf-widget="KeehsMgU" data-tf-inline-on-mobile={true} data-tf-hide-headers={true} data-tf-hide-footer={true}/>
    );
}